// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1Ap4I","list":"PatternAutocomplete_list__1ZiG7"};